<div class="temperatura-select dropdown">
    <button class="btn btn-light dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"
        [disabled]="disabled">
        <ng-template [ngIf]="temperatura">
            <span>
                <img [src]="temperatura.imageSrc" [attr.alt]="temperatura.nome" [style.width]="imageSize" [style.height]="imageSize">
                {{temperatura.nome}}
            </span>
        </ng-template>

        <ng-template [ngIf]="!temperatura">
            <span>
                Nenhuma Temperatura
            </span>
        </ng-template>        
    </button>
    
    <div class="dropdown-menu-container">
        <div class="dropdown-menu">
            <div class="dropdown-menu-itens">
                <a class="dropdown-item" 
                    [class.dropdown-item-select]="!idTemperatura"
                    (click)="select(null)">
                    Nenhuma Temperatura
                </a>
                <a *ngFor="let temp of temperaturas" 
                    class="dropdown-item"
                    [class.dropdown-item-select]="temp.id == idTemperatura"
                    (click)="select(temp)">
                    <img [src]="temp.imageSrc" [attr.alt]="temp.nome" [style.width]="imageSize" [style.height]="imageSize">                    
                    {{temp.nome}}
                </a>
            </div>
        </div>        
    </div>
</div>